import type { Scene } from "./Scene"
import { getWasmExports } from "./wasmRuntime"

export const LABEL_MAX_WIDTH = 120
export const LABEL_HEIGHT = 12
export const LABEL_GAP = 6

let outputCopy = new Uint16Array(0)

export function placeLabels(
  scene: Scene,
  scale: number,
  dotR: number,
): Uint16Array | null {
  const exports = getWasmExports()
  if (!exports || !scene.sync()) return null

  const outPtr = exports.place_labels(
    scale,
    dotR,
    LABEL_HEIGHT,
    LABEL_GAP,
    LABEL_MAX_WIDTH,
  )
  const outSize = exports.output_size()
  const outLen = outSize >> 1
  if (outputCopy.length !== outLen) outputCopy = new Uint16Array(outLen)
  outputCopy.set(new Uint16Array(exports.memory.buffer, outPtr, outLen))
  exports.free_all()
  return outputCopy
}
